// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__1q71O","modal":"Modal_modal__2J34Z","slide-down":"Modal_slide-down__50bqD"};